module.exports = __webpack_public_path__ + "img/icon-escalated-purple.13880e28.svg";